import { SORT_ORDER } from 'constants.js'
import { combineReducers } from 'redux'
import { emptyArray } from 'utils'

import {
  FETCH_CHANNELS_FLOORSPACE,
  FETCH_CHANNELS_FLOORSPACE_ERROR,
  FETCH_CHANNELS_FLOORSPACE_SUCCESS,
  SET_SORT,
  SORT_COLUMNS,
} from './constants'

const { ASC, DESC } = SORT_ORDER

const channelsFloorspace = (state = emptyArray, action) => {
  switch (action.type) {
    case FETCH_CHANNELS_FLOORSPACE_SUCCESS:
      return action.payload

    default:
      return state
  }
}

const isFetchingFloorspace = (state = false, action) => {
  switch (action.type) {
    case FETCH_CHANNELS_FLOORSPACE:
      return true

    case FETCH_CHANNELS_FLOORSPACE_ERROR:
    case FETCH_CHANNELS_FLOORSPACE_SUCCESS:
      return false

    default:
      return state
  }
}

const initialSortState = {
  sortBy: SORT_COLUMNS.FLOOR_SPACE_PER_STORE_CURRENT,
  order: DESC,
}
const sort = (state = initialSortState, { payload, type }) => {
  switch (type) {
    case SET_SORT:
      if (payload === state.sortBy) {
        return {
          order: state.order === DESC ? ASC : DESC,
          sortBy: payload,
        }
      }

      return {
        order: DESC,
        sortBy: payload,
      }

    default:
      return state
  }
}

export default combineReducers({
  channelsFloorspace,
  isFetchingFloorspace,
  sort,
})
